import { useState } from 'react';
import { useSelector } from 'react-redux';
import { FlexSpacer } from 'ui/flexSpacer';
import { ActionMenu } from 'ui/actionMenu';
import { AllowedActionMenuElements, MENU_ALIGNMENTS } from 'ui/actionMenu/types';
import { BUTTON_SIZES, SecondaryDestructiveButton } from 'ui/button';
import { ChevronDown16 } from 'ui/icons/aurora/16px';
import { selectFeatureFlags, selectIsBossOrSalesBossLevel } from 'core/userContext/selectors';
import { RetrySendUsageModal } from './RetrySendUsageModal';
import { ExtendTrialModal } from './ExtendTrialModal';
import { InsertZuoraPlanModal } from './InsertZuoraPlanModal';
import { useAllowPreview } from 'utils/hooks/useAllowPreview';
import { USAGE_LIMITS_PREVIEW_KEY } from 'modules/billing/constants';

const EXTEND_TRIAL = 'extendTrial';
const INSERT_ZUORA_PLAN = 'insertZuoraPlan';
const RETRY_SEND_USAGE = 'retrySendUsage';

export const BausControlsDropdown = () => {
  const [selectedModal, setSelectedModal] = useState('');
  const closeModal = () => setSelectedModal('');
  const isBausLevel = useSelector(selectIsBossOrSalesBossLevel);
  const { BillingUsageLimits } = useSelector(selectFeatureFlags);
  const isBillingLimitsPreviewEnabled = useAllowPreview(USAGE_LIMITS_PREVIEW_KEY);
  const isBillingLimitsEnabled = isBillingLimitsPreviewEnabled || BillingUsageLimits;

  const extendTrialOption = {
    as: AllowedActionMenuElements.Button,
    content: 'Update trial end date',
    id: EXTEND_TRIAL,
    onClick: () => setSelectedModal(EXTEND_TRIAL),
  };

  const insertZuoraPlanOption = {
    as: AllowedActionMenuElements.Button,
    content: 'Insert missing Zuora account',
    id: INSERT_ZUORA_PLAN,
    onClick: () => setSelectedModal(INSERT_ZUORA_PLAN),
  };

  const resendUsageOption = {
    as: AllowedActionMenuElements.Button,
    content: 'Retry send usage',
    id: RETRY_SEND_USAGE,
    onClick: () => setSelectedModal(RETRY_SEND_USAGE),
  };

  /** Remove Zuora option in updated page as it's no longer supported */
  const options = isBillingLimitsEnabled
    ? [extendTrialOption, resendUsageOption]
    : [extendTrialOption, insertZuoraPlanOption, resendUsageOption];

  return (
    <>
      {isBausLevel && (
        <FlexSpacer data-test="billing-baus-controls-dropdown" justifyContent="flex-end">
          <ActionMenu align={MENU_ALIGNMENTS.RIGHT} options={options}>
            <SecondaryDestructiveButton
              size={isBillingLimitsEnabled ? BUTTON_SIZES.LARGE : BUTTON_SIZES.MEDIUM}
            >
              <span>Baus</span>
              <ChevronDown16 />
            </SecondaryDestructiveButton>
          </ActionMenu>
          <RetrySendUsageModal isOpen={selectedModal === RETRY_SEND_USAGE} onClose={closeModal} />
          <ExtendTrialModal isOpen={selectedModal === EXTEND_TRIAL} onClose={closeModal} />
          <InsertZuoraPlanModal isOpen={selectedModal === INSERT_ZUORA_PLAN} onClose={closeModal} />
        </FlexSpacer>
      )}
    </>
  );
};
